/// <reference path="../../app.definition.ts" />
export enum FieldTypeEnum {
    HEADER_LABEL = 'header_label',
    LABEL = 'label',
    SELECT = 'select',
    PERSON = 'person',
    MULTI_SELECT = 'multiSelect',
    BUTTON = 'button',
    DATE = 'date',
    MULTI_SELECT_PERSON = 'multiSelectPerson',
    MULTI_SELECT_USER = 'multiSelectUser',
    INTEGER = 'int',
    SF_SELECT = 'sf-select',
    PAGINATED_SUB_LIST = 'paginatedSubList'
}
export enum FieldCategoryEnum {
    INPUT = 'input',
    FILTER = 'filter'
}
export enum DataTypeEnum {
    DATE = 'date',
    STRING = 'string'
}
export enum FieldSourceTypeEnum {
    CALL_API = 'call_api',
    CALL_CACHE = 'call_cache',
    STATIC = 'static',
    DEPENDENT = 'dependent',
    EXPRESSION = 'expression',
    EXECUTE_ACTION = 'execute_action',
    FROM_FIELD_OPTIONS = "fromFieldOptions"
}
export enum FieldEventTypeEnum {
    CALL_API = 'call_api',
    CALL_CACHE = 'call_cache',
    CALL_SERVICE = 'call_service',
    EXECUTE_ACTION = 'execute_action',
    EXECUTE_PROCESS = 'execute_process',
    FILTER_SUBJECTS = 'filter_subjects'
}
export enum FieldProcessTypeEnum {
    PRE = 'pre',
    POST = 'post',
    RUN = 'run'
}
export enum ValueSourceTypeEnum {
    CONTROLLER_VAR = 'controller_var',
    SERVICE_VAR = 'service_var',
    SELECT_FROM_OPTIONS = 'select_from_options',
    CALL_CACHE = 'call_cache',
    STATIC = 'static',
    SELECT_ALL_OPTIONS = 'selectAllOptions',
    EXECUTE_ACTION = 'execute_action',
    EXPRESSION = 'expression',
    FIELD_VALUE = 'field_value',
    SCOPE_VAR = 'scope_var',
    OPERATION = 'operation',
    SELECTED_VALUE = 'selected_value'
}
export enum SetTypeEnum {
    FIELD_OPTIONS = 'field_options',
    FIELD_ORIG_OPTIONS = 'field_orig_options',
    FIELD_VALUE = 'field_value',
    CONTROLLER_VAR = 'controller_var',
    SERVICE_VAR = "service_var",
    SCOPE_VAR = 'scope_var',
    ATTRIBUTE = 'attribute'
}
export enum DependencyTypeEnum {
    FIELD_VALUE = 'field_value',
    CONTROLLER_VAR = 'controller_var',
    SCOPE_VAR = 'scope_var'
}
export enum FieldOperationEnum {
    SET = "set",
    EXEC_ACTION = "execute_actions",
    EXEC_SERVICES = "execute_services",
    FIRE_EVENT = "fire_event"
}
export enum ChartTypeEnum {
    LINE = 'line',
    TABLE = 'table'
}
export enum StatisticsEnum {
    LATEST = 'latest',
    MIN = 'min',
    MAX = 'max',
    MEAN = 'mean'
};
export enum DataProcessTypeEnum {
    GROUP_BY = 'groupBy',
    MAP_FIELD_OPTIONS = 'mapFieldOptions',
    ADD_FIELDS = 'addFields',
    FILTER = "filter"
}
export enum DDOptionsSetTypeEnum {
    DISTINCT_FROM_RESULT = 'distinctFromResult',
    FILTER_FROM_PARENT = 'filterFromParent',
    GROUP_FROM_RESULT = 'groupFromResult',
    STATIC = 'static'
}
export enum FilterActionsEnum {
    //This enum describes actions that apply on or before filteration of data
    TOGGLE_COLUMN = 'toggle_column',
    TOGGLE_TABLE = 'toggle_table'
}
export enum SelectionTypeEnum {
    SELECT_ALL = 'selectAll',
    DESELECT_ALL = 'deselectAll',
    RETAIN = 'retain'
}

class EventSource {
    action: string;
    params: object;
    process: object;

    constructor(fEvent) {
        !!fEvent.action && (this.action = fEvent.action);
        !!fEvent.params && (this.params = fEvent.params);
        if (!!fEvent.process) {
            this.process = {};
            for (var key in fEvent.process) {
                !!fEvent.process[key] && (this.process[key] = new FieldProcess(key, fEvent.process[key]));
            }
        }
    }
}
export class FieldEvent extends EventSource {
    type: FieldEventTypeEnum;
    constructor(fEvent) {
        super(fEvent);
        !!fEvent.type && (this.type = fEvent.type as FieldEventTypeEnum);
    }
}

export class FieldSource extends EventSource {
    type: FieldSourceTypeEnum;
    value: string;
    constructor(fldSrc) {
        super(fldSrc);
        !!fldSrc.type && (this.type = fldSrc.type as FieldSourceTypeEnum);
        !!fldSrc.value && (this.value = fldSrc.value);
    }
}

export class FieldOptions {
    emptyText;
    datePickerOptions: { formatYear: string, startingDay: number };
    styleClass: { toSelf: string, toParent: string };
    withClear: boolean;
    constructor(options) {
        if (!!options) {
            this.emptyText = options.emptyText;
            this.styleClass = { toParent: options.styleClass.toParent, toSelf: options.styleClass.toSelf };
            !!options.datePickerOptions && (this.datePickerOptions = options.datePickerOptions);
            this.withClear = options.withClear;
        } else {
            this.emptyText = "";
            this.styleClass = { toParent: "", toSelf: "" };
            this.datePickerOptions = { formatYear: "", startingDay: null }
            this.withClear = false
        }
    }
}

export class FieldProcess {
    type: FieldProcessTypeEnum;
    perform: object;

    constructor(type, perform) {
        !!type && (this.type = type as FieldProcessTypeEnum);
        !!perform && (this.perform = perform);
        if (perform.hasOwnProperty(FieldOperationEnum.FIRE_EVENT)) {
            perform[FieldOperationEnum.FIRE_EVENT] = new FieldEvent(perform[FieldOperationEnum.FIRE_EVENT]);
        }
    }
}
export class FieldAttribute {
    name: string;
    value: string;
    constructor(attrib) {
        this.name = attrib.name;
        this.value = attrib.value;
    }
}

export class SubjListFieldOptions {
    filterConfig: any;
    customFilter: any;
    includeCustomAttributes: any;
    searchBy: any;
    searchFormat: string;
    searchPattern: string;
    teamDetails: any;
    constructor(opt) {
        this.filterConfig = opt.filterConfig;
        this.customFilter = opt.customFilter;
        this.includeCustomAttributes = opt.includeCustomAttributes;
        this.searchBy = opt.searchBy;
        this.searchFormat = opt.searchFormat;
        this.searchPattern = opt.searchPattern;
        this.teamDetails = opt.teamDetails;
    }
}

export class Field {
    id: number;
    type: FieldTypeEnum;
    label: string;
    name: string; //this would be the model name
    placeholder: string;
    source: FieldSource;
    events: object;
    options: FieldOptions;
    attributes: Array<FieldAttribute>;
    value: any;
    category: FieldCategoryEnum;
    additionalProps: object;
    ddOptions: any;
    origDdOptions: any;
    subjListOptions: SubjListFieldOptions;

    constructor(field) {
        this.id = field.id;
        this.type = field.type as FieldTypeEnum;
        this.label = field.label;
        this.name = field.name;
        this.placeholder = field.placeholder;
        this.source = new FieldSource(field.source);
        this.options = new FieldOptions(field.options);
        this.category = !!field.category ? field.category as FieldCategoryEnum : FieldCategoryEnum.INPUT;
        if (!!field.events) {
            this.events = {};
            for (var key in field.events) {
                if (Array.isArray(field.events[key])) {
                    var events = [];
                    field.events[key].forEach(evt => {
                        events.push(new FieldEvent(evt));
                    });
                    this.events[key] = events;
                } else {
                    this.events[key] = new FieldEvent(field.events[key]);
                }
            }
        };
        if (!!field.attributes) {
            this.attributes = [];
            for (var attrib of field.attributes) {
                this.attributes.push(new FieldAttribute(attrib));
            }
        }
        if (!!field.additionalProps) {
            this.additionalProps = field.additionalProps;
        } else {
            this.additionalProps = {};
        }
        if (!!field.subjListOptions) {
            this.subjListOptions = new SubjListFieldOptions(field.subjListOptions);
        } else {
            this.subjListOptions = new SubjListFieldOptions({});
        }
    }
}

export class SelectOption {
    id: number;
    parentId: number;
    groupId: number;
    label: string;
    type: string;
    disableSelection: boolean;

    constructor(id = null, label = null, parentId = null, type = null) {
        this.id = id;
        this.label = label;
        this.parentId = parentId;
        this.type = type;
    }
    deserialize(input: any) {
        !!input.id && (this.id = input.id);
        !!input.partyId && (this.id = input.partyId);
        !!input.parentId && (this.parentId = input.parentId);
        !!input.parentPartyId && (this.parentId = input.parentPartyId);
        !!input.groupId && (this.groupId = input.groupId);
        !!input.label && (this.label = input.label);
        !!input.name && (this.label = input.name);
        !!input.type && (this.type = input.type);
        this.disableSelection = input.disableSelection;

        return this;
    }
}

export class ReportMaster {
    fields: {};
    settings: any;

    constructor(config) {
        if (!!config) {
            if (Array.isArray(config.fields)) {
                this.fields = {};
                for (var i = 0; i < config.fields.length; i++) {
                    this.fields[config.fields[i].name] = new Field(config.fields[i]);
                }
            }
            this.settings = config.settings;
            if (!!this.settings && !!this.settings.events) {
                for (var event in this.settings.events) {
                    if (Array.isArray(this.settings.events[event])) {
                        var events = [];
                        this.settings.events[event].forEach(evt => {
                            events.push(new FieldEvent(evt));
                        });
                        this.settings.events[event] = events;
                    } else {
                        this.settings.events[event] = new FieldEvent(this.settings.events[event]);
                    }
                }
            }
        }
    }
}

export class StateOption {
    id: number;
    label: string;
    name: string;
    email: string;
    address: string;

    constructor(id = null, name = null, email = null, address = null) {
        this.id = id;
        this.name = name;
        this.email = email;
        this.address = address;
    }
    deserialize(input: any) {
        !!input.id && (this.id = input.id);
        !!input.partyId && (this.id = input.partyId);
        !!input.address && (this.address = input.address);
        !!input.email && (this.email = input.email);
        !!input.name && (this.name = input.name);
        !!input.name && (this.label = input.name);

        return this;
    }
}
